<script setup>
    import { useRoute } from 'vue-router'

    const props = defineProps({
        token: {
            type: String,
            required: true
        }
    })

    const route = useRoute();

    localStorage.setItem('apollo-token', props.token)
    if(route.query?.user){
        localStorage.setItem('authUser', route.query?.user);
    }
</script>